import React from 'react'
import { Row, Col, Avatar, Space, Button } from 'antd'
import CardComponent from '../../../components/CardComponent'
import { PrinterOutlined, EditOutlined } from '@ant-design/icons'
import _ from 'lodash'
import Logo from '../../../assets/images/logo_green2get_40@2x.png'
import LogoNoMaterial from '../../../assets/images/icon_no_material_402x.png'
import { getQuantityLabel, getHeroType } from '../../../utils'
import { PanelEx, CollapseEx, TableEx, Text, ListDiv } from '../index.style'
import { ButtonEx } from '../../HeroLocations/index.style'

const ListMaterial = (props) => {
  const { me, myProducts, onClickAdd, onClickEdit } = props
  const checkProduct = () => {
    let haveProduct = false
    myProducts.forEach((item) => {
      if (!_.isEmpty(item.products)) {
        haveProduct = true
      }
    })
    return haveProduct
  }

  const columns = [
    {
      title: 'วัสดุ',
      key: 'name',
      align: 'center',
      width: 350,
      render: (text, record) => (
        <Row justify="start">
          <Space>
            <img height={48} width={48} src={text.material.image} alt="" />
            <span>{record.material.name}</span>
          </Space>
        </Row>
      )
    },
    {
      title: 'จำนวนที่รับซื้อ',
      key: 'minQuantity',
      dataIndex: 'minQuantity',
      align: 'center',
      width: 150,
      render: (text, record) => <span>{getQuantityLabel(text)}</span>
    },
    {
      title: 'ราคาที่รับซื้อ (ต่อกิโลกรัม)',
      key: 'price',
      dataIndex: 'price',
      align: 'center',
      width: 150,
      render: (text, record) => <span>{`${Number(text).toFixed(2)} บาท`}</span>
    }
  ]

  return (
    <ListDiv>
      <CardComponent>
        {me && (
          <Row>
            <Col xs={0} sm={0} md={8} lg={8} xl={8}>
              <Space size="small">
                <Avatar size={72} src={Logo} />
                <Text size={20}>Green2Get</Text>
              </Space>
            </Col>
            <Col
              xs={12}
              sm={12}
              md={8}
              lg={8}
              xl={8}
              style={{ display: 'flex', justifyContent: 'center' }}>
              <Row justify="center">
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Space>
                    {/* <Avatar src={!_.isNull(me.avatar) ? me.avatar.url : ''} /> */}
                    <Text size={20}>{me.name}</Text>
                  </Space>
                </div>
              </Row>
            </Col>
            <Col xs={12} sm={12} md={8} lg={8} xl={8}>
              <Row justify="end">
                <Space direction="vertical" size="small">
                  <Text>ประเภท : {getHeroType(me.heroType).title}</Text>
                  <Text>เบอร์โทร : {me.tel || '-'}</Text>
                  <Text>Line ID : {me.lineId || '-'}</Text>
                </Space>
              </Row>
            </Col>
          </Row>
        )}
      </CardComponent>
      {checkProduct() ? (
        <div>
          <CollapseEx defaultActiveKey={['1']} expandIconPosition="right">
            {!_.isEmpty(myProducts) &&
              myProducts
                .filter((item) => item.products.length > 0)
                .map((item, index) => {
                  return (
                    <PanelEx
                      id={item.categoryId}
                      header={
                        <Row justify="center">
                          <span style={{ color: 'white', fontSize: 18 }}>
                            {item.categoryName}
                          </span>
                        </Row>
                      }
                      key={`${index + 1}`}>
                      <TableEx
                        id={item.id}
                        rowKey={(record) => {
                          return record.id
                        }}
                        dataSource={item.products}
                        columns={columns}
                        scroll={{ x: 800 }}
                        pagination={false}
                      />
                    </PanelEx>
                  )
                })}
          </CollapseEx>
          <Row justify="end" style={{ marginTop: 5 }}>
            <Space>
              <Button icon={<EditOutlined />} onClick={() => onClickEdit()}>
                แก้ไขข้อมูลวัสดุ
              </Button>
              <Button icon={<PrinterOutlined />}>พิมพ์ข้อมูล</Button>
            </Space>
          </Row>
        </div>
      ) : (
        <CardComponent>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: 500
            }}>
            <Space direction="vertical">
              <Row justify="center">
                <Avatar size={72} src={LogoNoMaterial} />
              </Row>
              <Text size={20}>คุณยังไม่มีวัสดุรีไซเคิลที่รับซื้อ</Text>
            </Space>
          </div>
        </CardComponent>
      )}
      <Row justify="center" style={{ marginTop: 5 }}>
        <ButtonEx color="#6ebf4b" type="primary" onClick={() => onClickAdd()}>
          เพิ่มวัสดุ
        </ButtonEx>
      </Row>
    </ListDiv>
  )
}

export default ListMaterial



// WEBPACK FOOTER //
// ./src/pages/AccountProduct/ListMaterial/index.js